export default __webpack_public_path__ + "7ea72f724e93663b94a1ec0562265761.png";